import React, { useEffect } from 'react';
import {
  Button,
  Chip,
  Card,
  Typography,
  Accordion,
  Grid,
  Dialog,
  AccordionSummary,
  AccordionDetails,
  Box,
} from '@mui/material';
import './WFHStatusCard.css';
import { WFHStatusType } from './WFHStatusconstants';
import { DialogBoxComponent } from '../../components/DialogBox/DialogBoxCard';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import { CANCEL_BUTTON_TEXT, SHOW_NOTIFICATION } from '../../constants';
import { WFH, WFHStatusButton } from './WFHStatusconstants';
import { useLocation } from 'react-router-dom';
import ShowWFHStatus from './WFHStatus.js';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { applyWFH, getWFHApplicationById } from '../../services/WFHService.js';
import moment from 'moment';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import FlakyOutlinedIcon from '@mui/icons-material/FlakyOutlined';
import { useDispatch, useSelector } from 'react-redux';
import KeycloakService from '../../services/KeycloakService';
import WFHTask from './WFHTask';
import { getUserProjects } from '../../services/UserService';
import { getEmployeesInProject } from '../../services/ProjectService';
import WFHTimings from './WFHTimingsDropdown';
import { YYYY_MM_DD } from './TaskConstants';
const WFHStatusCardComponent = (props) => {
  const {
    pageChange,
    wfh,
    wfhStatus,
    toggleEditOpen,
    isManagerOrAdmin,
    updateApplication,
    getWFHApplicationList,
    tasksData,
    setTasksData,
    refresh,
    setRefresh,
    getWFHTasks,
    officialHolidays,
    leavesList,
  } = props;
  const [open, setOpen] = React.useState(false);
  const [openCancel, setOpenCancel] = React.useState(false);

  const currentUserId = KeycloakService.getUserDetail();
  const location = useLocation();
  const [expanded, setExpanded] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [loader, setLoader] = React.useState(true);
  const [dialogContent, setDialogContent] = React.useState();
  const [confirmText, setConfirmText] = React.useState();
  const [comment, setComment] = React.useState();
  const [openTask, setOpenTask] = React.useState(false);
  const [userProjects, setUserProjects] = React.useState([]);
  const [approvalContext, setApprovalContext] = React.useState(null);
  const [newTaskData, setNewTaskData] = React.useState([]);
  const [editableWFHTasks, seteditableWFHTasks] = React.useState({});
  const [editable, setEditable] = React.useState(false);
  const [selectedDates, setSelectedDates] = React.useState([
    {
      startDate: moment(wfh.startDate),
      endDate: moment(wfh.endDate),
      key: 'selection',
    },
  ]);
  const dispatch = useDispatch();

  const cardState = useSelector((state) => state.cardState);

  useEffect(() => {
    setExpanded(cardState.expand);
  }, [cardState]);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const getProjectsList = async () => {
    const projectData = await getUserProjects(
      currentUserId,
      '',
      '',
      '',
      'ACTIVE',
    );
    if (projectData.isError == false) {
      setUserProjects(projectData.data.content);
    }
    if (projectData.status !== 200) {
      dipatchNotification(projectData.type, projectData.message);
    }
  };

  /**
   * Task-open: load application via existing Workflow GET with applicationId.
   * Prefer frozen approvalContext projects; fall back to live ACTIVE projects (legacy).
   */
  const loadProjectsForTaskDialog = async () => {
    const appResponse = await getWFHApplicationById(currentUserId, wfh.id);
    if (appResponse.isError === false) {
      const pageOrApp = appResponse.data?.data ?? appResponse.data;
      const content = pageOrApp?.content || pageOrApp;
      const application = Array.isArray(content) ? content[0] : content;
      const context = application?.approvalContext || null;
      setApprovalContext(context);
      if (context?.projects?.length) {
        const liveProjectsResponse = await getUserProjects(
          currentUserId,
          '',
          '',
          '',
          'ACTIVE',
        );
        const liveProjects =
          liveProjectsResponse.isError === false
            ? liveProjectsResponse.data?.data?.content ||
              liveProjectsResponse.data?.content ||
              []
            : [];
        const frozenProjects = [];
        for (const frozen of context.projects) {
          const liveMatch = liveProjects.find(
            (p) => p.projectId === frozen.projectId,
          );
          if (liveMatch) {
            frozenProjects.push(liveMatch);
          } else {
            const members = await getEmployeesInProject(frozen.projectId, '');
            const memberContent =
              members.data?.data?.content || members.data?.content || [];
            const projectName = memberContent[0]
              ? memberContent[0].projectName
              : `Project ${frozen.projectId}`;
            frozenProjects.push({
              id: frozen.projectId,
              projectId: frozen.projectId,
              projectName,
            });
          }
        }
        setUserProjects(frozenProjects);
        return;
      }
    }
    setApprovalContext(null);
    await getProjectsList();
  };

  const getTaskData = () => {
    const currentApplicationTasks = tasksData.filter(
      (item) => item.applicationId == wfh.id,
    );

    currentApplicationTasks.sort((obj1, obj2) =>
      obj1.dateOfWfh > obj2.dateOfWfh
        ? 1
        : obj1.dateOfWfh < obj2.dateOfWfh
          ? -1
          : 0,
    );
    setNewTaskData(currentApplicationTasks);
    setLoader(false);
  };
  const [check, setCheck] = React.useState(true);
  const getWFHRange = () => {
    let startDate;
    let endDate;

    if (!isManagerOrAdmin) {
      startDate = wfh.startDate;
      endDate = wfh.endDate;
    } else {
      startDate = wfh.applicationDTO.startDate;
      endDate = wfh.applicationDTO.endDate;
    }
    if (startDate === endDate) {
      return <>{moment(startDate).format('DD MMM YYYY')}</>;
    } else {
      return (
        <>
          {moment(startDate).format('DD MMM YYYY')} to{' '}
          {moment(endDate).format('DD MMM YYYY')}
        </>
      );
    }
  };

  const handleClose = () => {
    setComment(null);
    setOpen(false);
    setOpenCancel(false);
    setOpenTask(false);
    setEditable(false);
  };

  const addTask = async () => {
    await loadProjectsForTaskDialog();
    setEditable(false);
    setOpenTask(true);
  };
  const editTask = async () => {
    await loadProjectsForTaskDialog();
    setOpenTask(true);
    setEditable(true);
  };

  const handleOnConfirm = () => {
    let templateApplicationResponse = {
      id: wfh.id,
      status: ' ',
      comments: !comment ? 'No comments' : comment,
    };
    if (confirmText === 'Reject') {
      templateApplicationResponse = {
        ...templateApplicationResponse,
        status: 'REJECTED',
      };
    } else if (confirmText === 'Approve') {
      templateApplicationResponse = {
        ...templateApplicationResponse,
        status: 'APPROVED',
      };
    }
    updateApplication(templateApplicationResponse);
    setComment(null);
    setOpenCancel(false);
  };

  const cancelWFHPayload = () => {
    return {
      id: wfh.id,
      employeeId: currentUserId,
      status: 'CANCELLED',
      type: 'WFH',
    };
  };

  const cancelWFH = async () => {
    setOpenCancel(false);
    const cancelledWFHPayload = cancelWFHPayload();
    const WFHResponse = await applyWFH(cancelledWFHPayload);
    dipatchNotification(WFHResponse.type, WFHResponse.message);
    if (WFHResponse.isError === false) {
      setOpen(false);
      pageChange(null, 1);
      // getWFHApplicationList();
    }
  };

  React.useEffect(() => {
    getTaskData();
  }, [tasksData]);

  return (
    <div>
      {loader ? (
        <Stack>
          <Typography variant="h1">
            {<Skeleton sx={{ height: '9rem' }} />}
          </Typography>
        </Stack>
      ) : (
        <>
          <Card variant="outlined" sx={{ mb: 2 }}>
            <div className="wfh-status-container pb-0">
              <div className="space-between-container">
                <Typography sx={{ width: '30%' }} variant="h6">
                  {location.pathname !== '/manage' ? WFH : wfh.empName}
                </Typography>
                <Typography sx={{ width: '40%', textAlign: 'center' }}>
                  <CalendarMonthRoundedIcon
                    fontSize="small"
                    className="mr-1 mt-n1"
                  />
                  {getWFHRange()}
                </Typography>
                <Box sx={{ width: '30%', textAlign: 'right' }}>
                  {location.pathname === '/manage' ? (
                    <Chip
                      sx={{ marginRight: 1.5 }}
                      label="Work From Home"
                      color="secondary"
                      size="small"
                      variant="outlined"
                    />
                  ) : (
                    ''
                  )}
                  <Chip
                    label={wfhStatus}
                    color={
                      wfhStatus === 'APPROVED'
                        ? 'success'
                        : wfhStatus === 'REJECTED'
                          ? 'error'
                          : 'warning'
                    }
                    size="small"
                    variant="outlined"
                  />
                </Box>
              </div>
              <div className="flex-center-container">
                <div className="space-between-container">
                  <DialogBoxComponent
                    open={openCancel}
                    confirmText={confirmText}
                    cancelText={'Close'}
                    content={dialogContent}
                    onConfirm={
                      confirmText == 'Confirm' ? cancelWFH : handleOnConfirm
                    }
                    onCancel={handleClose}
                    icon={<FlakyOutlinedIcon color="primary" />}
                  />
                  <>
                    {wfh.status === 'APPROVED' ||
                    wfh.status === 'TASK_PENDING' ||
                    wfh.status === 'TASK_APPROVED' ? (
                      <div className="space-between-container">
                        <Button
                          variant="outlined"
                          size="small"
                          color="error"
                          sx={{ px: 1 }}
                          onClick={() => {
                            setOpenCancel(true);
                            setConfirmText('Confirm');
                            setDialogContent(
                              'Are you sure, you want to cancel this application?',
                            );
                          }}
                        >
                          {CANCEL_BUTTON_TEXT}
                        </Button>
                        {newTaskData.length > 0 ? (
                          <Button
                            variant="outlined"
                            size="small"
                            sx={{ px: 1, ml: 2 }}
                            onClick={editTask}
                          >
                            {WFHStatusButton.EDIT_TASK}
                          </Button>
                        ) : (
                          <Button
                            variant="outlined"
                            size="small"
                            sx={{ px: 1, ml: 2 }}
                            onClick={addTask}
                            disabled={moment(wfh.startDate).isAfter(
                              moment(new Date().setHours(0, 0, 0, 0)),
                            )}
                          >
                            {WFHStatusButton.ADD_TASK}
                          </Button>
                        )}
                      </div>
                    ) : wfhStatus === 'PENDING' || 'REJECTED' ? (
                      <div className="space-between-container">
                        <Button
                          variant="outlined"
                          size="small"
                          color="error"
                          sx={{ px: 1, ml: 2 }}
                          onClick={() => {
                            setOpenCancel(true);

                            setConfirmText('Confirm');
                            setDialogContent(
                              'Are you sure, you want to cancel this application?',
                            );
                          }}
                        >
                          {CANCEL_BUTTON_TEXT}
                        </Button>

                        <Button
                          variant="outlined"
                          size="small"
                          sx={{ px: 1, ml: 2 }}
                          onClick={() => toggleEditOpen(wfh)}
                        >
                          {WFHStatusButton.RESCHEDULE}
                        </Button>
                      </div>
                    ) : (
                      ''
                    )}
                    <Dialog
                      open={openTask}
                      fullWidth
                      maxWidth="md"
                      onClose={handleClose}
                    >
                      {check ? (
                        <WFHTask
                          taskData={newTaskData}
                          wfh={wfh}
                          selectedDates={selectedDates}
                          setSelectedDates={setSelectedDates}
                          userProjects={userProjects}
                          approvalContext={approvalContext}
                          handleClose={handleClose}
                          refresh={refresh}
                          setRefresh={setRefresh}
                          getWFHTasks={getWFHTasks}
                          editableWFHTasks={editableWFHTasks}
                          editable={editable}
                          officialHolidays={officialHolidays}
                          leavesList={leavesList}
                        ></WFHTask>
                      ) : (
                        ''
                      )}
                    </Dialog>
                  </>
                </div>
              </div>{' '}
              {moment(wfh.startDate).isAfter(
                moment(new Date().setHours(0, 0, 0, 0)),
              ) && wfh.status === 'APPROVED' ? (
                <Typography
                  sx={{
                    marginTop: 1,
                    width: '100%',
                    textAlign: 'center',
                    fontSize: '12px',
                  }}
                >
                  <InfoOutlinedIcon color="info" sx={{ fontSize: '13px' }} />
                  {`You can add task after ${wfh.startDate}`}
                </Typography>
              ) : (
                ''
              )}
              {isManagerOrAdmin &&
              !KeycloakService.hasRole(['admin']) &&
              wfh.applicationDTO.isUpdatedByAdmin ? (
                <Typography
                  sx={{
                    marginTop: 1,
                    width: '100%',
                    textAlign: 'center',
                    fontSize: '12px',
                  }}
                >
                  <InfoOutlinedIcon color="info" sx={{ fontSize: '13px' }} />
                  Application {wfh.applicationDTO.status.toLowerCase()} by Admin
                </Typography>
              ) : (
                ''
              )}
              <div>
                <Accordion
                  expanded={expanded}
                  onChange={() => setExpanded(!expanded)}
                  disableGutters
                  elevation={0}
                  sx={{ width: '100%', border: 'none' }}
                >
                  <Grid
                    className="wfh-container pb-0 pt-0"
                    sx={{ display: 'flex', justifyContent: 'center' }}
                  >
                    <AccordionSummary expandIcon={<KeyboardArrowDownIcon />} />
                  </Grid>
                  <Grid
                    className="wfh-container pb-0 pt-0"
                    sx={{ width: '100%' }}
                  >
                    <AccordionDetails className="p-0">
                      <Typography variant="body1" className="mt-1 mb-3">
                        {/* {location.pathname === "/WFH"
                          ? wfh.applicationDTO.reason
                          : wfh.reason} */}
                        {wfh.reason}
                      </Typography>
                      <Typography variant="body1" className="mt-1 mb-1">
                        {expanded &&
                        (wfhStatus !== 'APPROVED' ||
                          (wfhStatus === 'APPROVED' &&
                            newTaskData.length === 0)) ? (
                          <strong>Approval Status:</strong>
                        ) : (
                          ''
                        )}
                      </Typography>
                      {/* {location.pathname === "/manage" && wfhStatus !== "APPROVED"
? expanded &&
wfh.approverList.map((managerResponse) => (
<ShowWFHStatus
managerResponse={managerResponse}
key={managerResponse.id}
rows={rows}
setRows={setRows}
closeLeaveStatus={setExpanded}
/>
)) */}
                      {expanded ? (
                        (wfhStatus !== 'APPROVED' &&
                          wfhStatus !== 'TASK_PENDING' &&
                          wfhStatus !== 'TASK_APPROVED') ||
                        ((wfhStatus === 'APPROVED' ||
                          wfhStatus === 'TASK_PENDING' ||
                          wfhStatus === 'TASK_APPROVED') &&
                          newTaskData.length === 0) ? (
                          wfh.applicationStatusDTOS.map((managerResponse) => (
                            <ShowWFHStatus
                              managerResponse={managerResponse}
                              key={managerResponse.id}
                              rows={rows}
                              setRows={setRows}
                              closeLeaveStatus={setExpanded}
                            />
                          ))
                        ) : newTaskData.length > 0 ? (
                          <Box sx={{ mb: '1rem' }}>
                            <WFHTimings
                              taskData={newTaskData}
                              refresh={refresh}
                              setRefresh={setRefresh}
                              getWFHTasks={getWFHTasks}
                              userProjects={userProjects}
                            />
                          </Box>
                        ) : (
                          ''
                        )
                      ) : (
                        ''
                      )}
                    </AccordionDetails>
                  </Grid>
                </Accordion>
              </div>
            </div>
          </Card>
        </>
      )}
    </div>
  );
};

export default WFHStatusCardComponent;
